import { Api } from '../../utils/config';
import { Http } from '../../utils/http';

const url = Api().host + "/votecenter/groups";

const getHomeList = async () => {
  const item = await Http.get(url)
  return item.data.list;
}


export{
    getHomeList
}


// WEBPACK FOOTER //
// ./src/components/activities-list/api.ts